import React from 'react';
import { FiAlertCircle, FiRefreshCw } from 'react-icons/fi';

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-4 text-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-6">
        <div className="flex flex-col items-center">
          <FiAlertCircle className="w-12 h-12 text-red-500 mb-4" />
          <h3 className="text-xl font-medium text-gray-800 mb-2">Something went wrong</h3>
          <p className="text-gray-600 mb-6">{message}</p>
          <button
            onClick={onRetry}
            className="flex items-center gap-2 px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 transition-colors"
          >
            <FiRefreshCw className="w-4 h-4" />
            <span>Try Again</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;